import { Check } from "lucide-react";
import { cn } from "@/utils/css";
import { kmaToMarket } from "@/utils/markets";
import {useMediaQuery} from "react-responsive";

export const MarketLoadsList = ({ items = {}, value = {}, setValue, className, centralMarketKey }) => {
    const isDesktop = useMediaQuery({
        query: "(min-width: 1200px)",
    });

    const handleToggle = (marketKey) => {
        if (marketKey === centralMarketKey) return;
        const newValue = { ...value };
        if (newValue[marketKey]) {
            delete newValue[marketKey];
        } else {
            newValue[marketKey] = true;
        }
        setValue(newValue);
    };

    const entries = Object.entries(items);

    //Show Central Market key as first item in the list
    const orderedEntries =
        centralMarketKey != null && centralMarketKey in items
            ? [[centralMarketKey, items[centralMarketKey]], ...entries.filter(([k]) => k !== centralMarketKey)]
            : entries;

    return (
        <div
            className={cn(
                "overflow-auto rounded-[8px] border border-cm-p-outline bg-cm-p-surface",
                isDesktop
                    ? "w-[258px] max-h-[360px] py-[12px] px-[18px]"
                    : "w-[200px] max-h-[250px] py-[12px] px-[18px]",
                className
            )}
            style={{ boxShadow: "0px 4px 14px -3px rgba(93, 93, 93, 0.08)" }}
        >
            <div className="grid grid-cols-[1fr_auto_24px] gap-x-4 text-[14px] text-cm-p-text-secondary mb-[12px]">
                <span className="font-normal">Markets</span>
                <span className="font-normal text-right">Loads</span>
                <span />
            </div>
            <div className="flex flex-col gap-[12px]">
                {orderedEntries.map(([marketKey, loads]) => {
                    const isSelected = !!value[marketKey];
                    const isCentral = marketKey === centralMarketKey;
                    return (
                        <button
                            key={marketKey}
                            type="button"
                            onClick={() => handleToggle(marketKey)}
                            disabled={isCentral}
                            className={cn(
                                "grid grid-cols-[1fr_auto_24px] gap-x-4 items-center text-left rounded",
                                isCentral && "cursor-default"
                            )}
                        >
                            <span className="text-[14px] font-medium text-cm-p-text-primary truncate min-w-0">
                                {kmaToMarket[marketKey] || marketKey}
                            </span>
                            <span className="text-[14px] font-medium text-cm-p-text-primary tabular-nums text-right">
                                {loads}
                            </span>
                            <div
                                className={cn(
                                    "w-4 h-4 border-2 rounded flex items-center justify-center shrink-0 justify-self-end",
                                    "border-cm-p-outline",
                                    {
                                        "border-cm-p-accent-600 bg-cm-p-accent-600": isSelected,
                                        "opacity-40": isCentral,
                                    }
                                )}
                            >
                                {isSelected && <Check className="size-3 text-white" />}
                            </div>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};
